import React, { useState, useEffect } from "react";
import $ from "jquery";
import "jquery-validation";

const Form = ({ isOpen, onClose, serviceDetails = null }) => {
  const [formData, setFormData] = useState({ name: "", email: "", tel: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Initialize validation when modal opens
      setTimeout(() => {
        $("#modal-form").validate({
          rules: {
            name: {
              required: true,
              minlength: 2
            },
            email: {
              required: true,
              email: true
            },
            tel: {
              digits: true,
              minlength: 10,
              maxlength: 15
            },
            message: {
              required: true,
              minlength: 10
            }
          },
          messages: {
            name: {
              required: "Please enter your name",
              minlength: "Name must be at least 2 characters"
            },
            email: {
              required: "Please enter your email",
              email: "Please enter a valid email address"
            },
            tel: {
              digits: "Please enter valid phone number",
              minlength: "Phone must be at least 10 digits",
              maxlength: "Phone must not exceed 15 digits"
            },
            message: {
              required: "Please enter your message",
              minlength: "Message must be at least 10 characters"
            }
          },
          errorElement: "span",
          errorClass: "text-danger",
          errorPlacement: function(error, element) {
            error.insertAfter(element);
          }
        });
      }, 100);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!$("#modal-form").valid()) {
      return;
    }
    
    setIsSubmitting(true);

     //  http://localhost/Anchor-point/php/submit_contact.php

    try {
      const response = await fetch("/php/submit_contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.tel,
          subject: "",
          message: formData.message,
          form_type: "discovery_call",
          service_title: serviceDetails?.service_title || "",
          duration: serviceDetails?.duration || "",
          format: serviceDetails?.format || ""
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert(result.message);
        setFormData({ name: "", email: "", tel: "", message: "" });
        $("#modal-form")[0].reset();
        onClose?.();
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Only render if isOpen is true
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} style={overlayStyle}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={modalStyle}
      >
        <button className="modal-close" onClick={onClose} style={closeBtnStyle}>
          &times;
        </button>
        <div className="modal-header">
          <h3 style={{ marginBottom: "20px" }}>Send us a message</h3>
        </div>
        <form id="modal-form" className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="name">Your Name *</label>
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="email">Email *</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="tel">Mobile Number</label>
            <input
              id="tel"
              name="tel"
              type="tel"
              className="form-control"
              value={formData.tel}
              onChange={handleChange}
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="message">Your Message *</label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              rows="5"
              value={formData.message}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="btn-new w-100" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

// Styles (unchanged but kept for completeness)
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};
const modalStyle = {
  backgroundColor: "#fff",
  padding: "2rem",
  borderRadius: "12px",
  width: "90%",
  maxWidth: "450px",
  position: "relative",
  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
};
const closeBtnStyle = {
  position: "absolute",
  top: "10px",
  right: "15px",
  border: "none",
  background: "none",
  fontSize: "28px",
  cursor: "pointer",
  color: "#666",
};

export default Form;
